import { createFileRoute } from "@tanstack/react-router";
import {
    accountSettingsRoute,
    AccountSettings,
} from "@/features/account-access";

export const Route = createFileRoute("/settings/account")({
    ssr: accountSettingsRoute.ssr,
    head: accountSettingsRoute.head,
    component: AccountSettings,
});
